import {
    useQueryClient,
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRuleSet } from '../../interfaces'
import { createRuleSet } from '../../../../services/dtServices'

export const useCreateRuleSet = (
    orgId: string,
    entityId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof createRuleSet>>,
    Error,
    string
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (ruleSetName: string) => {
            return createRuleSet(orgId, entityId, ruleSetName, false)
        },
        //client side optimistic update
        onMutate: (newRuleInfo: string) => {
            queryClient.setQueryData(
                ['rulesets', orgId, entityId],
                (prevRuleSets: any) =>
                    [
                        {
                            name: newRuleInfo,
                            id: (Math.random() + 1).toString(36).substring(7),
                            rules: [],
                            readOnly: false,
                            isDefault: false,
                        },
                        ...(prevRuleSets?.data || []),
                    ] as IRuleSet[],
            )
        },
        //refetch rules after mutation
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['rulesets', orgId, entityId],
            }),
    })
}
